import { PermissionsEnum } from "@/auth/interfaces";
import { cellNotFilter, formatDateWithTimeCell, gridSizeMdLg12, ROUTER_PATHS, TABLE_CONSTANTS, useCheckPermissions, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { EstadoComponente, GeneralTable, } from "@/shared/components/ui";
//ModalProgress, 
import { MRT_ColumnDef, MRT_RowData } from "material-react-table";
import { useMemo, useState } from "react";
import { getSolicitudesEgreso,  useFetchSolicitudesEgreso, } from "@/shared/actions/erp";
//useCreateSolicitudesIngresos,
import { EstadosSolicitudPeodidoEnum, MaterialTransferido } from "@/shared/interfaces";
import { Grid, IconButton, Tooltip, } from "@mui/material";
import { SolicitudesEgreso } from "@/shared/interfaces/erp/compras/solicitudes-egreso.interface";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useUiStore } from "@/store/ui";

import { useNavigate } from "react-router-dom";
import { Outbound } from "@mui/icons-material";
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import ModalObservacionGeneral from "@/shared/components/ui/ModalObservacionesGeneral";
import DetallesProductosEstados from "../revision-solicitud-pedido/DetallesProductosEstados";

type DetalleUsuarios = {
    id?: number;
    estado_solicitud?: string;
    observaciones?: {
        observacionRevisionSolicitudPedido?: string;
        observacionesSolicitudPedido?: string;
    }
}


export default function SolicitudPedidosUsuariosAprobadasPagina() {
    useCheckPermissions(PermissionsEnum.api_view_solicitudegreso);
    //** state */
    
    const handleCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
    const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
    const [isModalOpen2, setIsModalOpen2] = useState(false)
    const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);
    const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);
    const [idSolicitudEgreso, setIdSolicitudEgreso] = useState(false)
    //
    const navigate = useNavigate();
    //state
    const [tabValue, setTabValue] = useState(0);
    const [productosListos, setProductosListos]=useState<MaterialTransferido[]>([])


    const onSaveEdit = () => {
        setConfirmDialog({
            isOpen: true,
            title: '¿Estás seguro de que deseas generar la trasferencia?',
            subtitle: 'Por favor, confirma para proceder con la Trasferencia.',
            onConfirm() {
                setConfirmDialogIsOpen(false)
                return navigate(`${ROUTER_PATHS.inventario.transferenciaInventarioSolicitudEgresoNav.replace(':id_solicitudegreso', String(idSolicitudEgreso))}`);
            },
            onClose() {
                setConfirmDialogIsOpen(false)
            },


        })

    }
   
    const columns = useMemo<MRT_ColumnDef<DetalleUsuarios>[]>(
        () => [
            {
                accessorKey: "numero_referencia",
                header: "N° solicitud",
                size: 150,
                //with: 150,
            },
            {
                ...cellNotFilter,
                accessorKey: "user.username",
                header: "usuario",
                size: 100,
                //with: 100
            },
            {
                ...cellNotFilter,
                accessorKey: "bodega_data.nombre",
                header: "bodega",
                size: 200,

            },
            {
                accessorKey: "observaciones.observacionRevisionSolicitudPedido",
                header: "observacion del Revisor",
                size: 200,
                Cell: ({ row }) => {
                    return <ModalObservacionGeneral
                        texto={
                            row.original.observaciones?.observacionRevisionSolicitudPedido || 'N/A'
                        }
                        title="observación del Revisor"
                    />
                }
                //Cell: ({ row }) => row.original?.observaciones?.observacionRevisionSolicitudPedido || 'N/A',
            },
            {
                ...cellNotFilter,
                accessorKey: "fecha_creacion",
                header: "Fecha de creación",
                size: 200,
                Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_creacion')
            },
            {
                ...cellNotFilter,
                accessorKey: "estado_solicitud",
                header: "estado",

                Cell: ({ row }) => (
                    row.original.estado_solicitud != null ?
                        <EstadoComponente backgroundColor="green" texto={row.original.estado_solicitud || ''} /> : null


                ),
            },
        ],

        []
    );


    /* const onDetails = (e: MRT_RowData) => {
        //console.log('productos', e)
        handleCopiarLista(e.productos)
        //setDetails(JSON.parse(JSON.stringify(e.productos)));
        //setIsModalOpen(true);
        setIsModalOpen2(true)
        setIdSolicitudEgreso(e.id_solicitudegreso)
    } */
    const onDetails = async (e: MRT_RowData) => {
        setIdSolicitudEgreso(e.id_solicitudegreso)
        setIsModalOpen2(true)

        try {
            const resp = await getSolicitudesEgreso(e.id_solicitudegreso)
            const productos = (resp?.data?.productos || []).map((p: any) => ({
                ...p,
                cantidad: p.cantidad ?? 0,
                cantidad_a_entregar: Math.min(p.cantidad_aprobada, Number(p.producto_data?.stock_actual))
            })) as MaterialTransferido[]
            handleCopiarLista(productos)
        } catch (error) {
            handleCopiarLista(e.productos)  
        }
    }

    const {
        ///globalFilter,
        pagination,
        searchTerm,
        //onChangeFilter,
        setPagination,
        dateBefore,
        dateAfter,
        //onChangeRangeDate,
        //cleanFilter,

    } = useTableFilter();

    const { pageIndex, pageSize } = pagination;
    const { columnFilters, setColumnFilters, filterObject } = useTableServerSideFiltering()

    const {
        data: solicitudPedidoAprobadosRes,
        isLoading: isLoadingSolicitudesPedidoPaging,
        isRefetching,
    } = useFetchSolicitudesEgreso({
        page_size: pageSize,
        page: pageIndex + 1,
        estado_solicitud: EstadosSolicitudPeodidoEnum.APROBADAS,
        fecha_after: dateAfter,
        fecha_before: dateBefore,
        numero_referencia: searchTerm,
        ...filterObject,
        filterByState: false,
    })

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
            </Grid >
            <Grid item xs={12}>
                <GeneralTable<SolicitudesEgreso>
                    columns={columns}
                    data={solicitudPedidoAprobadosRes?.data?.data || []}
                    isLoading={isLoadingSolicitudesPedidoPaging}
                    isRefetching={isRefetching}
                    enableGlobalFilter={false}
                    pagination={pagination}
                    onPaging={setPagination}
                    rowCount={solicitudPedidoAprobadosRes?.data?.count}
                    //actionsColumnSize={120}
                    canEdit={false}
                    enableColumnActions={true}
                    ///
                    columnFilters={columnFilters}
                    onColumnFiltersChange={setColumnFilters}
                    enableManualFiltering={true}
                    enableSorting={false}
                    //crud
                    canDelete={false}
                    positionActionsColumn="first"
                    enableEditing={true}
                    ///
                    actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
                    showCustomActionBtnSpace={true}
                    customActionBtnSpace={(value) => {
                        return (
                            <>
                                <Grid container>
                                    <Grid item>
                                        <Tooltip title='Transferir' placement="top">
                                            <IconButton
                                                onClick={() => { onDetails(value) }}
                                            >
                                                <SwapHorizIcon />
                                            </IconButton>

                                        </Tooltip>
                                    </Grid>

                                </Grid>
                            </>
                        )

                    }}
                />
            </Grid>

            {isModalOpen2 && (
                <ScrollableDialogProps
                    open={isModalOpen2}
                    title="Productos"
                    minWidth="80%"
                    onCloseIcon={() => { setIsModalOpen2(false), clearSelectedItems(), setTabValue(0) }}
                    showConfirmBtn={tabValue === 0 && productosListos.length>0}
                    confirmTextBtn={
                        <>
                            <Outbound />
                            Generar Trasferencia
                        </>
                    }
                    confirmVariantBtn={'outlined'}
                    onConfirm={() => onSaveEdit()}
                    contentNode={
                        <Grid container spacing={2}>
                            <Grid item  {...gridSizeMdLg12}>
                                <DetallesProductosEstados
                                    tabValue={tabValue}
                                    onTabChange={setTabValue}
                                    onProductos={e=>{
                                        //console.log('Productos_value',e)
                                        setProductosListos(e)
                                    }}
                                    /* onProductos={e => {
                                    }} */
                                />
                            </Grid>
                        </Grid>
                    }
                />
            )} 
        </Grid>

    );
}
